import React from 'react';
import Button from './Button';

interface AccountTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const AccountTitle: React.FC<AccountTitleProps> = ({ children, className = '' }) => {
  return (
    <h2 data-component-id="src/components/ui/AccountComponents.tsx:11:4" data-component-path="src/components/ui/AccountComponents.tsx" data-component-line="11" data-component-file="AccountComponents.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%7D" className={`font-tt-norms-extra-black text-base leading-5 uppercase text-global-1 mb-2 tracking-wider ${className}`}>
      {children}
    </h2>
  );
};

interface AccountSubtitleProps {
  children: React.ReactNode;
  className?: string;
}

export const AccountSubtitle: React.FC<AccountSubtitleProps> = ({ children, className = '' }) => {
  return (
    <h3 data-component-id="src/components/ui/AccountComponents.tsx:24:4" data-component-path="src/components/ui/AccountComponents.tsx" data-component-line="24" data-component-file="AccountComponents.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%7D" className={`font-tt-norms-bold text-base leading-5 text-global-1 mb-2 ${className}`}>
      {children}
    </h3>
  );
};

interface AccountTextProps {
  children: React.ReactNode;
  className?: string;
}

export const AccountText: React.FC<AccountTextProps> = ({ children, className = '' }) => {
  return (
    <div data-component-id="src/components/ui/AccountComponents.tsx:37:4" data-component-path="src/components/ui/AccountComponents.tsx" data-component-line="37" data-component-file="AccountComponents.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`font-tt-norms-regular text-base leading-[21px] text-global-1 ${className}`}>
      {children}
    </div>
  );
};

interface AccountButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const AccountButton: React.FC<AccountButtonProps> = ({ 
  children, 
  onClick, 
  className = '',
  disabled = false,
  type = 'button'
}) => {
  return (
    <Button data-component-id="src/components/ui/AccountComponents.tsx:59:4" data-component-path="src/components/ui/AccountComponents.tsx" data-component-line="59" data-component-file="AccountComponents.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%7D"
      variant="secondary"
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`bg-[#3D1C1A] text-[#FEF5E6] px-4 py-2 rounded font-tt-norms-bold text-base w-fit hover:opacity-90 transition-colors ${className}`}
    >
      {children}
    </Button>
  );
};

interface AccountSectionProps {
  children: React.ReactNode;
  className?: string;
}

export const AccountSection: React.FC<AccountSectionProps> = ({ children, className = '' }) => {
  return (
    <div data-component-id="src/components/ui/AccountComponents.tsx:78:4" data-component-path="src/components/ui/AccountComponents.tsx" data-component-line="78" data-component-file="AccountComponents.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`bg-[#F6E8D8] rounded-[16px] p-8 flex flex-col gap-6 ${className}`}>
      {children}
    </div>
  );
};